import React, { useState, useEffect } from 'react';
import Breadcrumbs from "../../../components/breadcrumbs";
import { Box, Typography, Card } from "@mui/material";
import CommonHeader from '../../../components/admin/reports/commonHeader';
import OrderHistoryTable from '../../../components/admin/reports/orderHistory/table';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderHistoryWatcher } from '../../../redux/actionCreators/admin/reports';
import {TABLE_HEAD} from '../../../components/admin/reports/orderHistory/table';

const OrderHistory = () => {
    const { ReportsReducers: { OrderHistoryList } } = useSelector((state) => state)

    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState('')
    const [searchVal, setSearchVal] = useState([])
    const [page, setPage] = useState(1);

    useEffect(() => {
        let data = { "ACTION": "AdminContractorList" }
        dispatch(getOrderHistoryWatcher(data))
    }, [dispatch])

    function escapeRegExp(value) {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    const handleSearch = (e) => {
        let val = e.target.value
        setSearchText(val);
        const searchRegex = new RegExp(escapeRegExp(val), 'i');
        const filteredRows = OrderHistoryList.filter((row) => {
            return Object.keys(row).some((field) => {
                return searchRegex.test(row[field]);
            });
        });

        setSearchVal(filteredRows);
        setPage(1)
    }

    const handleSubmitAction = (fromDate, toDate) => {
        const data = {
            ACTION: "AdminSearchContractorList",
            FromDate: fromDate,
            ToDate: toDate,
        }
        dispatch(getOrderHistoryWatcher(data))
        setPage(1)
    }

    return (
        <>
            <Box p="24px">

                <Breadcrumbs content={["Reports ", "Order History"]} />

                <Box mt="14px" mb='8px' display='flex' alignItems='center' >
                    <Typography variant="t24_700">Order History</Typography>
                </Box>
                <Box p='10px 0'>
                    <CommonHeader handleSearch={handleSearch} searchText={searchText} handleSubmitAction={handleSubmitAction} rowData = {OrderHistoryList} columnData ={TABLE_HEAD} type= {'order'}/>
                </Box>
                <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}`, borderRadius: "6px 6px 0px 0px", padding: '20px' }}>
                    <OrderHistoryTable page={page} setPage={setPage} searchVal={searchVal} searchText={searchText} dataList={OrderHistoryList} />
                </Card>
                
            </Box>
        </>
    )
}

export default OrderHistory;